import script from "./NotificationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationPage.vue?vue&type=script&setup=true&lang=js"

import "./NotificationPage.vue?vue&type=style&index=0&id=9750c01e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9750c01e"]])

export default __exports__